import React, { useState, useRef, useEffect } from 'react';
import { Globe } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { SUPPORTED_LANGS } from '../i18n/index';
import './LanguageSwitcher.css';

const LANG_LABELS = { de: 'DE', en: 'EN', es: 'ES' };
const LANG_FULL = { de: 'Deutsch', en: 'English', es: 'Español' };

/**
 * LanguageSwitcher
 * Props:
 *   variant — 'pills' (default) | 'dropdown'
 */
export default function LanguageSwitcher({ variant = 'pills' }) {
  const { lang, setLang } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  if (variant === 'dropdown') {
    return (
      <div className="lang-dropdown" ref={ref}>
        <button
          className="lang-dropdown-trigger"
          onClick={() => setOpen(v => !v)}
          title={LANG_FULL[lang]}
          aria-label="Change language"
        >
          <Globe size={14} strokeWidth={1.75} />
          <span>{LANG_LABELS[lang]}</span>
        </button>
        {open && (
          <div className="lang-dropdown-menu">
            {SUPPORTED_LANGS.map(l => (
              <button
                key={l}
                className={`lang-dropdown-item${l === lang ? ' active' : ''}`}
                onClick={() => { setLang(l); setOpen(false); }}
              >
                <span className="lang-dropdown-abbr">{LANG_LABELS[l]}</span>
                <span className="lang-dropdown-full">{LANG_FULL[l]}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  // Pills variant (default)
  return (
    <div className="lang-pills">
      {SUPPORTED_LANGS.map(l => (
        <button
          key={l}
          className={`lang-pill${l === lang ? ' active' : ''}`}
          onClick={() => setLang(l)}
          title={LANG_FULL[l]}
        >
          {LANG_LABELS[l]}
        </button>
      ))}
    </div>
  );
}
